/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTicket = createReactComponent("ticket", "IconTicket", [
  ["path", { d: "M15 5l0 2", key: "svg-0" }],
  ["path", { d: "M15 11l0 2", key: "svg-1" }],
  ["path", { d: "M15 17l0 2", key: "svg-2" }],
  [
    "path",
    {
      d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2",
      key: "svg-3"
    }
  ]
]);

export { IconTicket as default };
//# sourceMappingURL=IconTicket.js.map
